import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { ADD_USER_QUERY } from '../services/GraphQLQueries'
import ValidateEmail from '../components/EmailValidation'
import Modal from '../layouts/Modal'
import SideMenu from '../layouts/SideMenu'
import '../layouts/stylesheets/loader-style.css'
import { FcGoogle } from 'react-icons/fc'

export default function Signup() {
  const [addUser, { loading }] = useMutation(ADD_USER_QUERY)
  const [stateLoading, setLoading] = useState(false)
  const [signupForm, setSignupForm] = useState({
    email: '',
    fullname: '',
    password: '',
  })
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false)
  const navigate = useNavigate()

  const handleChange = (event) => {
    setSignupForm({ ...signupForm, [event.target.id]: event.target.value })
  }
  const [formErrors, setFormErrors] = useState({ errors: {} })
  const handleSuccessDismiss = () => {
    setIsSuccessModalOpen(false)
    navigate('/signin')
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    let errors = {}
    let proceed = true
    if (signupForm.email.length < 3 || !ValidateEmail(signupForm.email)) {
      errors.email = 'Please enter a valid email address.'
      proceed = false
    }
    if (signupForm.password.length < 8) {
      errors.password = 'Please enter your password.'
      proceed = false
    }
    if (signupForm.fullname.length < 3) {
      errors.fullname = 'Please enter your name.'
      proceed = false
    }
    if (!proceed) {
      setFormErrors({ ...formErrors, errors })
      return
    }

    try {
      setLoading(true)
      const { error } = ''
      if (error) throw error
      // alert('Check your email for the login link!')
      const response = await addUser({
        variables: {
          ...signupForm,
          canUseMagicLink: false,
        },
      })
      const data = response.data
      console.log('response:', data)
      // if the login response succeeds
      if (data?.addUser?.id) {
        setIsSuccessModalOpen(true)
      } else {
        console.log('some error:', data?.addUser?.error)
        if (data?.addUser?.error?.toLowerCase()?.includes('password')) {
          setFormErrors({
            errors: { ...formErrors, password: data?.addUser?.error },
          })
        } else {
          setFormErrors({
            errors: { ...formErrors, email: data?.addUser?.error },
          })
        }
      }
      // navigate("/FirstTracker/Main");
    } catch (error) {
      alert(error.error_description || error.message)
    } finally {
      setLoading(false)
    }
  }
  return (
    <div className="flex justify-center items-center" aria-live="polite">
      {isSuccessModalOpen && (
        <Modal
          setIsModalOpen={setIsSuccessModalOpen}
          backGroundClass={'darkBG'}
          dismissModal={handleSuccessDismiss}
        >
          <div className="grid gap-5 text-center">
            <div>
              <h2 className="text-2xl font-semibold text-gray-900">
                Account created
              </h2>
              <p className="mt-3 text-sm leading-6 text-gray-600">
                Success. Please check your email and use the verification link to activate your account before signing in.
              </p>
            </div>
            <button
              type="button"
              onClick={handleSuccessDismiss}
              className="w-full rounded-md bg-black px-4 py-3 text-sm font-semibold text-white hover:bg-gray-900"
            >
              Continue to sign in
            </button>
          </div>
        </Modal>
      )}
      <SideMenu hideBackArrow></SideMenu>
      <div className="w-full flex justify-center">
        {loading || stateLoading ? (
          <>
            <div className="loader-wrapper">
              <div className="flex justify-center items-center">
                <div className="grid gap-10">
                  <div className="loader"></div>
                  <div className="text-center">Registering...</div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="grid gap-6 md:w-96 w-72 mb-36">
            <div className="flex justify-center">
              {/* <img
                className="w-[46px] h-[46px]"
                src={LogoMark}
                alt="LogoMark"
              /> */}
            </div>
            <div className="flex justify-center">
              <h1 className="w-full text-3xl font-semibold font-unbounded text-gray-900 text-center">
                Create an account
              </h1>
            </div>
            <div className="flex justify-center">
              <h1 className="text-gray-600">Start your 30-day free trial.</h1>
            </div>
            <div>
              <p className="text-gray-700 text-sm font-medium mb-1">Name*</p>
              <input
                type="text"
                id="fullname"
                className=" text-black border border-gray-300 placeholder-gray-500 rounded-md block w-full p-2"
                placeholder="Enter your name"
                required
                value={signupForm.fullname}
                onChange={handleChange}
              />
              {formErrors.errors.fullname ? (
                <p
                  style={{
                    color: '#f44',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {formErrors.errors.fullname}
                </p>
              ) : (
                ''
              )}
            </div>
            <div>
              <p className="text-gray-700 text-sm font-medium mb-1">Email*</p>
              <input
                type="email"
                id="email"
                className=" text-black border border-gray-300 placeholder-gray-500 rounded-md block w-full p-2"
                placeholder="Enter your email"
                required
                value={signupForm.email}
                onChange={handleChange}
              />
              {formErrors.errors.email ? (
                <p
                  style={{
                    color: '#f44',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {formErrors.errors.email}
                </p>
              ) : (
                ''
              )}
            </div>
            <div>
              <p className="text-gray-700 text-sm font-medium mb-1">
                Password*
              </p>
              <input
                type="password"
                id="password"
                className=" text-black border border-gray-300 placeholder-gray-500 block w-full p-2"
                placeholder="Create a password"
                required
                value={signupForm.password}
                onChange={handleChange}
              />
              <p className="text-gray-600 text-sm font-normal mt-1">
                Must be at least 12 characters.
              </p>
              {formErrors.errors.password ? (
                <p
                  style={{
                    color: '#f44',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}
                >
                  {formErrors.errors.password}
                </p>
              ) : (
                ''
              )}
            </div>
            <input
              type="button"
              id="continue"
              onClick={handleLogin}
              className=" font-semibold text-center rounded-md w-full p-3 bg-black text-white border border-purple-500 cursor-pointer"
              placeholder="Get Started"
              value="Get Started"
            />
            <button
              type="button"
              id="google-login"
              disabled
              hidden
              className="hidden font-semibold text-center rounded-md w-full p-3 bg-gray-100 text-gray-400 border cursor-not-allowed"
              aria-disabled="true"
              aria-hidden="true"
            >
              <FcGoogle className="inline h-6 w-6 mr-2 "></FcGoogle>Sign up with
              Google
            </button>
            <p className="text-center text-sm text-gray-600">
              Already have an account?{' '}
              <NavLink
                className="font-bold text-black"
                to="/signin"
              >
                Log in
              </NavLink>
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
